export const LIQUID_ASSET_INFO_TYPE_COUNT = "liquidAssetCount";
export const LIQUID_ASSET_INFO_TYPE_FORM = "liquidAssetInfoForm";
